import MyAccountPage from './MyAccountPage'

export default MyAccountPage
// eslint-disable-next-line import/export
export * from './MyAccountPage'
